import { useState } from "preact/hooks";

export const useRerender = () => {
  const [counter, setCounter] = useState(0);
  return {
    rerender: () => setCounter((x) => x + 1),
    counter,
  };
};
